<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs" />
    <b-alert variant="danger" :show="hasError">{{errorMessage}}</b-alert>
    <b-row :style="containerStyle"  v-if="selectedChoice ==  null">
      <b-col>
        <br>
        <b-form inline class="mb-3">
          <label for="team" class="mr-3">My Current team: </label>
          <b-form-select id="team" :options="teams" v-model="team">
          </b-form-select>
        </b-form>
      </b-col>
    </b-row>
    <b-row :style="containerStyle">
      <b-col lg="6">
        <br>
        <data-section v-if="workflow" ref="headerForm" :section="headerSection" :boldTintColor="workflow.bold_tint_color"></data-section>
      </b-col>
      <b-col lg="6">
        <br>
        <h4 v-if="selectedChoice">
          {{selectedChoice.heading}}
        </h4>
        <b-list-group v-if="availableChoices.length > 0">
          <b-list-group-item v-for="(choice, choiceIndex) in availableChoices" :key="choiceIndex" class="align-items-start" :to="choiceRoute(choice)">
            <list-item :icon="choiceIcon(choice)" :heading="choice.heading" :text="choice.details" :disclosure="true"></list-item>
          </b-list-group-item>
        </b-list-group>
        <br>
      </b-col>

    </b-row>
  </b-container>
</template>

<script>
// import moment from 'moment'
import API from '@/lib/api'
import DataSection from '@/components/DataSection'
import ListItem from '@/components/ListItem'
// import _ from 'lodash'

export default {
  name: 'NewEventChoose',
  components: { DataSection, ListItem },
  data () {
    var selectedTeamId = this.$route.query.selectedTeamId != null && this.$route.query.selectedTeamId !== '' ? parseInt(this.$route.query.selectedTeamId) : null
    var data = {
      tracker: {
        originatorTeamId: this.$route.query.otid != null && this.$route.query.otid !== '' ? parseInt(this.$route.query.otid) : null,
        workflowId: this.$route.query.wfid != null && this.$route.query.wfid !== '' ? parseInt(this.$route.query.wfid) : null,
        jobNumber: this.$route.query.job,
        trackerId: this.$route.query.tid != null && this.$route.query.tid !== '' ? parseInt(this.$route.query.tid) : null,
        originatorData: this.$route.query.odata
      },
      selectedChoiceId: this.$route.query.selectedChoiceId !== '' ? this.$route.query.selectedChoiceId : null,
      breadcrumbs: [{text: 'My Vos Voco', to: '/'}, {text: 'New Event', to: this.$route.fullPath, active: true}],
      workflow: null,
      currentChoice: null,
      hasError: false,
      errorMessage: null,
      teams: this.$store.getters.teams
        .map((team) => { return {text: team.name, value: team} }),
      team: selectedTeamId != null
            ? this.$store.getters.teams.find((team) => { return team.id === selectedTeamId })
            : this.$store.state.currentTeam,
      headerSection: null
    }
    return data
  },
  computed: {
    containerStyle () {
      var style = {}
      if (this.workflow != null) {
        style.backgroundColor = this.workflow.light_tint_color
      }
      return style
    },
    availableChoices () {
      var choices = []
      if (this.selectedChoice != null) {
        choices = this.selectedChoice.choices
      } else if (this.workflow != null) {
        choices = this.workflow.choices
      }
      choices = choices.filter((choice) => {
        if (choice.availability === 'all') {
          return true
        } else if (choice.availability === 'originator') {
          return this.originatorTeamId === this.team.id
        }
      })
      return choices
    },
    selectedChoice () {
      if (this.workflow != null && this.selectedChoiceId != null) {
        return this.findChoice(this.workflow.choices, this.selectedChoiceId)
      } else {
        return null
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.updateData()
    }
  },
  mounted () {
    this.fetchWorkflow()
  },
  methods: {
    fetchWorkflow () {
      this.hasError = false
      API.get(`/workflows/${this.tracker.workflowId}`, {}, this.$store.getters.authHeaders)
        .then((response) => {
          this.workflow = response.data
          this.updateHeaderSection()
        })
    },
    findChoice (choices, choiceId) {
      var foundChoice = null
      if (choices != null) {
        choices.forEach((choice) => {
          if (foundChoice == null) {
            if (choice.id === choiceId) {
              foundChoice = choice
            } else {
              foundChoice = this.findChoice(choice.choices, choiceId)
            }
          }
        })
      }
      console.log('found choice')
      console.log(foundChoice)
      return foundChoice
    },
    updateTeam () {
      this.$store.commit('selectCurrentTeam', this.team)
    },
    updateData () {
      var selectedTeamId = this.$route.query.selectedTeamId != null && this.$route.query.selectedTeamId !== '' ? parseInt(this.$route.query.selectedTeamId) : null
      this.tracker = {
        originatorTeamId: this.$route.query.otid != null && this.$route.query.otid !== '' ? parseInt(this.$route.query.otid) : null,
        workflowId: this.$route.query.wfid != null && this.$route.query.wfid !== '' ? parseInt(this.$route.query.wfid) : null,
        jobNumber: this.$route.query.job,
        trackerId: this.$route.query.tid != null && this.$route.query.tid !== '' ? parseInt(this.$route.query.tid) : null,
        originatorData: this.$route.query.odata
      }
      this.selectedChoiceId = this.$route.query.selectedChoiceId !== '' ? this.$route.query.selectedChoiceId : null
      this.team = selectedTeamId != null
            ? this.$store.getters.teams.find((team) => { return team.id === selectedTeamId })
            : this.$store.state.currentTeam
    },
    updateHeaderSection () {
      var dataItems = []
      var dataEntryItems = []
      if (this.workflow != null) {
        dataItems.push({
          name: 'Workflow',
          type: 'string',
          value: this.workflow.name
        })
      }
      if (this.tracker.jobNumber != null) {
        dataItems.push({
          name: this.terminology('job_number', 'Job Number'),
          type: 'string',
          value: this.tracker.jobNumber
        })
      }
      this.headerSection = {
        heading: 'Tracker Details',
        image_url: this.workflow.image_url,
        data_items: dataItems,
        data_entry_items: dataEntryItems
      }
    },
    terminology (term, fallback) {
      const terms = this.workflow.text_terms
      if (terms != null && terms[term] != null) {
        return terms[term]
      } else {
        return fallback
      }
    },
    choiceIcon (choice) {
      if (choice.choices != null && choice.choices.length > 0) {
        return 'choice_multi'
      } else {
        return 'choice_multi'
      }
    },
    choiceRoute (choice) {
      var query = {
        otid: this.tracker.originatorTeamId,
        wfid: this.tracker.workflowId,
        job: this.tracker.jobNumber,
        tid: this.tracker.trackerId,
        odata: this.tracker.originatorData,
        selectedTeamId: this.team.id,
        selectedChoiceId: choice.id
      }
      if (choice.interstitial != null) {
        return { path: '/events/new/interstitial', query: query }
      } else if (choice.choices != null && choice.choices.length > 0) {
        return { path: '/events/new/choose', query: query }
      } else {
        return { path: '/events/new', query: query }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/NewEventChoose.vue